import withdrawalPaymentFilesEn from './en/withdrawalPaymentFiles.json';
import withdrawalPaymentFilesEs from './es/withdrawalPaymentFiles.json';

export const withdrawalPaymentFilesModuleEn = withdrawalPaymentFilesEn;
export const withdrawalPaymentFilesModuleEs = withdrawalPaymentFilesEs;
